import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { validateShipmentTrackingNumber } from '../../helpers/formHelpers/formHelpers';
import { getQueryParam } from '../../helpers/url/urlHelpers';
import usePostboxes from '../../hooks/usePostboxes';
import Button from '../base/button';
import FormikFieldWrapper from '../base/forms/formikFieldWrapper';
import FormikSelect from '../base/forms/formikSelect';
import { StyledFormikField } from '../base/forms/input';
import { Column, Columns } from '../base/grid';
import { getPostboxesSelectOptions } from '../registerShipment/registerShipmentForm/stepShipment/stepShipmentForm/helpers';

interface Props {
	values: any;
	setFieldTouched: any;
	setFieldValue: any;
	isSubmitting: boolean;
	errors: any;
	touched: any;
}

const PostboxDeliveryFormFields: FC<Props> = ({
	values,
	setFieldTouched,
	setFieldValue,
	isSubmitting,
	// errors,
	// touched,
}) => {
	const { t } = useTranslation('generalForm');
	const query = getQueryParam('q');
	const { postboxes, postboxesLoading } = usePostboxes();

	useEffect(() => {
		if (query && validateShipmentTrackingNumber(query)) setFieldValue('trackingnumber', query);
	}, [query, setFieldValue]);

	if (postboxesLoading || postboxes == null) {
		return null;
	}

	const postBoxesSelectOptions = getPostboxesSelectOptions(postboxes);

	return (
		<div>
			<Columns>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="trackingnumber"
						languageComponent="generalForm"
						label={`${t('trackingnumber')} *`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="trackingnumber"
							name="trackingnumber"
							placeholder={t('trackingnumber')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper name="name" languageComponent="generalForm" label={`${t('name')} *`} smallLabel>
						<StyledFormikField type="text" id="name" name="name" placeholder={t('name')} />
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						label={`${t('choosePostbox')} *`}
						smallLabel
						name="postbox"
						languageComponent="generalForm">
						<FormikSelect
							id="postbox"
							name="postbox"
							value={values.postbox}
							options={postBoxesSelectOptions}
							onBlur={setFieldTouched}
							placeholder={`${t('choosePostbox')}`}
							onChange={setFieldValue}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="customerEmail"
						languageComponent="generalForm"
						label={`${t('email')} *`}
						smallLabel>
						<StyledFormikField
							type="text"
							id="customerEmail"
							name="customerEmail"
							placeholder={t('email')}
						/>
					</FormikFieldWrapper>
				</Column>
				<Column desktopSmall={1 / 3} tablet={1 / 2}>
					<FormikFieldWrapper
						name="phone"
						languageComponent="generalForm"
						label={`${t('phone')} *`}
						smallLabel>
						<StyledFormikField type="number" id="phone" name="phone" placeholder={t('phone')} />
					</FormikFieldWrapper>
				</Column>

				{/* <Column>
                    <Captcha
                        schemaName="captchaValid"
                        setFieldTouched={setFieldTouched}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        touched={touched}
                    />
                </Column> */}
			</Columns>

			<Columns>
				<Column>
					<Button wide primary type="submit" isLoading={isSubmitting}>
						{t('submit')}
					</Button>
				</Column>
			</Columns>
		</div>
	);
};

export default PostboxDeliveryFormFields;
